export default __webpack_public_path__ + "static/media/analyse.61076b8c.svg";